import { ShortcodeStringBuilder } from "../../utils/shortcode-string-builder";
export class ArtestGalleryBuilder {
    static compile(gallery, clear = false) {
        ArtestGalleryBuilder.compileItemsContainer(gallery, clear);
    }
    static compileItemsContainer(gallery, clear = false) {
        let wrapper = gallery.elem;
        let container_elem = clear ? null : wrapper.querySelector("div.artest-campaign-gallery");
        if (container_elem && container_elem.parentNode != wrapper)
            container_elem = null;
        if (!container_elem) {
            container_elem = document.createElement("div");
            container_elem.className = "artest-campaign-gallery";
            wrapper.appendChild(container_elem);
        }
        let ol_elem = clear ? null : wrapper.querySelector("div.artest-campaign-gallery > ol.oeuvres");
        if (ol_elem && ol_elem.parentNode != container_elem)
            ol_elem = null;
        if (!ol_elem) {
            ol_elem = document.createElement("ol");
            ol_elem.className = "oeuvres";
            container_elem.appendChild(ol_elem);
        }
        gallery.DOM = { oeuvres: ol_elem, container: container_elem };
    }
}
export class ArtestGallery {
    constructor(elem, options, oeuvres, artists) {
        this.defaults = {
            item_heading: '[artist-name suffix=":"] [oeuvre-title] [completed prefix="(" suffix=")"]'
        };
        this.oeuvres = {};
        this.artists = {};
        this.DOM = {
            oeuvres: null,
            container: null
        };
        console.log("ArtestGallery.constructor() :: ", arguments);
        elem.artestGallery = this;
        this.elem = elem;
        this.options = options || {};
        this.options.img_size = this.options.img_size || 200;
        if (parseInt(String(this.options.img_size)) > 0) {
            this.options.img_size = parseInt(String(this.options.img_size));
        }
        else {
            this.options.img_size = 200;
        }
        if (!this.options.item_heading) {
            this.options.item_heading = this.defaults.item_heading;
        }
        this.init(oeuvres, artists || {}, function () {
            this.build(false);
        });
    }
    init(oeuvres, artists, callback) {
        var _a, _b;
        console.log("ArtestGallery.init() :: ", arguments);
        this.item_heading_builder = new ShortcodeStringBuilder(this.options.item_heading || this.defaults.item_heading);
        this.oeuvres = {};
        this.artists = {};
        const cArtists = this.artists;
        const gArtists = {};
        for (const i in oeuvres) {
            const v = oeuvres[i];
            const w = v.with = v.with || {};
            if (w.client_artist) {
                cArtists[w.client_artist.uid] = w.client_artist;
            }
            if (w.artist) {
                gArtists[w.artist.uid] = w.artist;
            }
            this.oeuvres[v.uid] = v;
        }
        for (const i in artists) {
            const v = artists[i];
            cArtists[v.uid] = v;
            if ((_a = v.with) === null || _a === void 0 ? void 0 : _a.artist) {
                gArtists[v.with.artist.uid] = v.with.artist;
            }
        }
        for (const uid in cArtists) {
            const artist = cArtists[uid];
            artist.with = artist.with || {};
            artist.with.artist = artist.with.artist || undefined;
            if (gArtists[artist.artist_uid]) {
                artist.with.artist = gArtists[artist.artist_uid];
            }
            else {
                console.warn("Missing ARTIST of CLIENT_ARTIST", artist);
            }
        }
        for (const uid in oeuvres) {
            const oeuvre = oeuvres[uid];
            oeuvre.with = oeuvre.with || {};
            oeuvre.with.artist = oeuvre.with.artist || null;
            oeuvre.with.client_artist = oeuvre.with.client_artist || null;
            let client_artist = cArtists[oeuvre.artist_uid];
            if (client_artist) {
                oeuvre.with.client_artist = client_artist;
                if ((_b = client_artist.with) === null || _b === void 0 ? void 0 : _b.artist) {
                    oeuvre.with.artist = client_artist.with.artist;
                }
                else {
                    console.warn("Missing ARTIST of OEUVRE", oeuvre);
                }
            }
            else {
                console.warn("Missing CLIENT_ARTIST of OEUVRE", oeuvre);
            }
        }
        callback.call(this, null);
    }
    compileDOM(clear = false) {
        ArtestGalleryBuilder.compile(this, clear);
    }
    build(clear = true) {
        if (clear) {
            this.elem.innerHTML = "";
        }
        this.compileDOM(clear);
        this.render(this.oeuvres, clear);
    }
    render(oeuvres, clear = true) {
        let listElem = this.DOM.oeuvres;
        if (listElem) {
            if (clear) {
                this.DOM.oeuvres.innerHTML = "";
            }
            for (const i in this.oeuvres) {
                const oeuvre = this.oeuvres[i];
                try {
                    let li_e = clear ? null : listElem.querySelector(`li[data-client_oeuvre_uid="${oeuvre.uid}"]`);
                    if (li_e && li_e.parentNode != listElem)
                        li_e = null;
                    if (!li_e) {
                        li_e = document.createElement("li");
                        li_e.dataset["client_oeuvre_uid"] = oeuvre.uid;
                        listElem.appendChild(li_e);
                    }
                    li_e = this.buildGalleryOeuvreElement(oeuvre, li_e, clear);
                }
                catch (error) {
                    console.error("ArtestGallery.render() :: Failed to apply oeuvre element, ", error, oeuvre);
                }
            }
        }
    }
    buildGalleryOeuvreElement(oeuvre, elem, clear = true) {
        var _a, _b, _c, _d, _e;
        const img_size = `${this.options.img_size}x${this.options.img_size}^`;
        let bg_img_url = this.options.missing_image_url || `https://artest.net/i/?size=${img_size}`;
        let thumb_img_url = this.options.missing_image_url || "https://artest.net/i/?size=64x64^";
        let e_a = clear ? null : elem.querySelector(`a.single-page-link`);
        if (e_a && e_a.parentNode != elem)
            e_a = null;
        if (!e_a) {
            e_a = document.createElement("a");
            e_a.className = "single-page-link";
            elem.appendChild(e_a);
        }
        if (!e_a.href) {
            if (this.options.link_type == "none") {
            }
            else if (this.options.link_type == "image") {
                e_a.href = bg_img_url;
            }
            else if (this.options.link_type == "oeuvre-page") {
                e_a.href = this.options.single_page_url + "?uid=" + oeuvre.uid;
            }
            else {
            }
        }
        let e_img = clear ? null : elem.querySelector(`a.single-page-link > div.img`);
        if (e_img && e_img.parentNode != e_a)
            e_img = null;
        if (!e_img) {
            e_img = document.createElement("div");
            e_img.className = "img";
            e_a.appendChild(e_img);
        }
        elem.$img = e_img;
        const e_data = document.createElement("div");
        const e_title = document.createElement("p");
        if ((_b = (_a = oeuvre.with) === null || _a === void 0 ? void 0 : _a.oeuvre) === null || _b === void 0 ? void 0 : _b.img_uid) {
            bg_img_url = `https://artest.net/i/${oeuvre.with.oeuvre.img_uid}?size=${img_size}`;
            thumb_img_url = `https://artest.net/i/${oeuvre.with.oeuvre.img_uid}?size=64x64^`;
            if (this.options.img_crop && oeuvre.with.images) {
                try {
                    const edges = (_e = (_d = (_c = oeuvre.with.images[oeuvre.with.oeuvre.img_uid]) === null || _c === void 0 ? void 0 : _c.framing) === null || _d === void 0 ? void 0 : _d.edges) === null || _e === void 0 ? void 0 : _e[this.options.img_crop];
                    if (edges === null || edges === void 0 ? void 0 : edges.sides) {
                        const o = edges.sides;
                        const _crop = encodeURIComponent(`${parseInt(String(100 * (o.right - o.left)))}x${parseInt(String(100 * (o.bottom - o.top)))}+${parseInt(String(100 * o.left))}+${parseInt(String(100 * o.top))}`);
                        bg_img_url += "&crop=%25" + _crop;
                        thumb_img_url += "&crop=%25" + _crop;
                    }
                }
                catch (err) {
                    console.error(err);
                }
            }
        }
        elem.dataset.thumb_img_url = thumb_img_url;
        if (this.options.lazy_loading && this.options.img_size && this.options.img_size > 64) {
            e_img.style.backgroundImage = `url(${thumb_img_url})`;
            elem.runLazyLoad = function () {
                delete elem.runLazyLoad;
                const img = new Image();
                img.onload = img.onerror = function () {
                    e_img.style.backgroundImage = `url(${bg_img_url})`;
                };
                img.src = bg_img_url;
            };
        }
        else {
            e_img.style.backgroundImage = `url(${bg_img_url})`;
        }
        e_a.appendChild(e_data);
        e_data.className = "data";
        e_data.appendChild(e_title);
        e_title.className = "heading";
        e_title.innerHTML = this.item_heading_builder.compile(oeuvre);
        return elem;
    }
    static Inject(elem, options, data) {
        elem.gallery = new ArtestGallery(elem, options, data.oeuvres, data.artists);
    }
}
